var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForum = function SvgForum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 2.667v4.667H3.947l-.78.78V2.667zm.667-1.333H2.5c-.367 0-.667.3-.667.666v9.334L4.5 8.667h6.667c.366 0 .666-.3.666-.667V2c0-.367-.3-.667-.666-.667M14.5 4h-1.333v6H4.5v1.334c0 .366.3.666.667.666H12.5l2.667 2.667v-10c0-.367-.3-.667-.667-.667"
  })));
};
export default SvgForum;